import * as Contentful from 'contentful'
import { TypeComponentForm } from './component-form'
import { TypeComponentIframe } from './component-iframe'
import { TypeComponentTextInput } from './component-text-input'
import { TypeComponentSelect } from './component-select'
import {
  TypeAssetImage,
  TypeAssetLottieAnimation,
  TypeAssetVideo,
  TypeComponentCtaButton,
  TypeComponentLink,
  TypeComponentDynamic,
  TypeComponentSignUpFormMask,
  TypeItemFeatureHighlight,
  TypeItemGlobalVariable,
  TypeItemCtaGroup,
  TypeItemIconList,
  TypeItemShortcode,
  TypeItemEventOrArticle,
  TypeItemTestimonial,
  TypeItemTrustedBy,
  TypePage,
  TypeSectionCitationGenerator,
  TypeSectionCitationRules,
  TypeSectionGrammarCheck,
  TypeSectionGroup,
  TypeSectionHero,
  TypeSectionMultiColumn,
  TypeSectionSingleColumn,
  TypeSectionTestimonials,
  TypeSectionTrustedBy,
  TypeSectionTwoColumn,
  TypeSeoMetadata,
  TypeSingleColumn,
  TypeVariationContainerDeviceType,
  TypeSectionTabs,
  TypeSectionLinkableBoxes,
  TypeSectionGoTemplatesTool,
  TypeVariationContainerAuthAndDeviceTypeCta,
  TypeSectionDynamic,
  TypeAssetLottieInteractiveAnimation,
} from './index'
import { TypeSectionFaq } from './section-faq'
import { TypeVariationConditionalSelect } from './conditional-select'
import { UnresolvedEntryLink } from '@lib/types/unresolved-link'

export enum ComponentContentTypes {
  Page = 'page',
  PageWrapper = 'pageWrapper',
  SeoMetadata = 'seoMetadata',
  AssetImage = 'assetImage',
  AssetLottieAnimation = 'assetLottieAnimation',
  AssetLottieInteractiveAnimation = 'assetLottieInteractiveAnimation',
  AssetVideo = 'assetVideo',
  ComponentCtaButton = 'componentCtaButton',
  ComponentForm = 'componentForm',
  ComponentIframe = 'componentIframe',
  ComponentLink = 'componentLink',
  ComponentDynamic = 'componentDynamic',
  ComponentTable = 'componentTable',
  ComponentTextInput = 'componentTextInput',
  ComponentSelect = 'componentSelect',
  ComponentSignUpFormMask = 'componentSignUpFormMask',
  ComponentPlansModule = 'componentPlansModule',
  ComponentSocialShareWidget = 'componentSocialShareWidget',
  ComponentEmptyStub = 'ComponentEmptyStub',
  ItemGlobalVariable = 'globalVariable',
  ItemShortcode = 'itemShortcode',
  ItemFeatureHighlight = 'itemFeatureHighlight',
  ItemEventOrArticle = 'itemEventOrArticle',
  ItemTestimonial = 'itemTestimonial',
  ItemTrustedBy = 'itemTrustedBy',
  ItemIconList = 'itemIconList',
  ItemCtaGroup = 'itemCtaGroup',
  SectionCitationGenerator = 'sectionCitationGenerator',
  SectionCitationRules = 'sectionCitationRules',
  SectionDynamic = 'sectionDynamic',
  SectionGrammarCheck = 'sectionGrammarCheck',
  SectionFaq = 'sectionFaq',
  SectionHero = 'sectionHero',
  SectionMultiColumn = 'sectionMultiColumn',
  SectionSingleColumn = 'sectionSingleColumn',
  SectionTestimonials = 'sectionTestimonials',
  SectionTrustedBy = 'sectionTrsutedBy', // #ToDo create a migration for typo
  SectionTwoColumns = 'sectionTwoColumns',
  SingleColumn = 'singleColumn',
  SectionGroup = 'sectionGroup',
  SectionGoTemplatesTool = 'sectionGoTemplatesTool',
  VariationContainerDeviceType = 'variationContainerDeviceType',
  VariationContainerAuthAndDeviceTypeCta = 'variationContainerAuthAndDeviceTypeCta',
  VariationContainerPersonalization = 'variationContainerPersonalization',
  VariationContainerConditionalSelect = 'variationContainerConditionalSelect',
  SectionTabs = 'sectionTabs',
  SectionVerticalTabs = 'sectionVerticalTabs',
  SectionUseCase = 'sectionUseCaseModule',
  SectionLinkableBoxes = 'sectionLinkableBoxes',
  NinetailedMergeTag = 'nt_mergetag',
  ComponentBanner = 'componentBanner',
  AssetPdf = 'assetPdf',
}

export type FieldsOf<T> = T extends Contentful.Entry<unknown> ? T['fields'] : never
export type EntryTypeByContentType<K extends ComponentContentTypes> = K extends typeof ComponentContentTypes.Page
  ? TypePage
  : K extends typeof ComponentContentTypes.SeoMetadata
    ? TypeSeoMetadata
    : K extends typeof ComponentContentTypes.AssetImage
      ? TypeAssetImage
      : K extends typeof ComponentContentTypes.AssetLottieAnimation
        ? TypeAssetLottieAnimation
        : K extends typeof ComponentContentTypes.AssetVideo
          ? TypeAssetVideo
          : K extends typeof ComponentContentTypes.ComponentCtaButton
            ? TypeComponentCtaButton
            : K extends typeof ComponentContentTypes.ComponentForm
              ? TypeComponentForm
              : K extends typeof ComponentContentTypes.ComponentIframe
                ? TypeComponentIframe
                : K extends typeof ComponentContentTypes.ComponentLink
                  ? TypeComponentLink
                  : K extends typeof ComponentContentTypes.ComponentDynamic
                    ? TypeComponentDynamic
                    : K extends typeof ComponentContentTypes.ComponentTextInput
                      ? TypeComponentTextInput
                      : K extends typeof ComponentContentTypes.ComponentSelect
                        ? TypeComponentSelect
                        : K extends typeof ComponentContentTypes.ComponentSignUpFormMask
                          ? TypeComponentSignUpFormMask
                          : K extends typeof ComponentContentTypes.ItemGlobalVariable
                            ? TypeItemGlobalVariable
                            : K extends typeof ComponentContentTypes.ItemShortcode
                              ? TypeItemShortcode
                              : K extends typeof ComponentContentTypes.ItemFeatureHighlight
                                ? TypeItemFeatureHighlight
                                : K extends typeof ComponentContentTypes.ItemTestimonial
                                  ? TypeItemTestimonial
                                  : K extends typeof ComponentContentTypes.ItemEventOrArticle
                                    ? TypeItemEventOrArticle
                                    : K extends typeof ComponentContentTypes.ItemTrustedBy
                                      ? TypeItemTrustedBy
                                      : K extends typeof ComponentContentTypes.ItemIconList
                                        ? TypeItemIconList
                                        : K extends typeof ComponentContentTypes.ItemCtaGroup
                                          ? TypeItemCtaGroup
                                          : K extends typeof ComponentContentTypes.SectionCitationGenerator
                                            ? TypeSectionCitationGenerator
                                            : K extends typeof ComponentContentTypes.SectionCitationRules
                                              ? TypeSectionCitationRules
                                              : K extends typeof ComponentContentTypes.SectionGrammarCheck
                                                ? TypeSectionGrammarCheck
                                                : K extends typeof ComponentContentTypes.SectionFaq
                                                  ? TypeSectionFaq
                                                  : K extends typeof ComponentContentTypes.SectionHero
                                                    ? TypeSectionHero
                                                    : K extends typeof ComponentContentTypes.SectionMultiColumn
                                                      ? TypeSectionMultiColumn
                                                      : K extends typeof ComponentContentTypes.SectionSingleColumn
                                                        ? TypeSectionSingleColumn
                                                        : K extends typeof ComponentContentTypes.SectionTestimonials
                                                          ? TypeSectionTestimonials
                                                          : K extends typeof ComponentContentTypes.SectionTrustedBy
                                                            ? TypeSectionTrustedBy
                                                            : K extends typeof ComponentContentTypes.SectionTwoColumns
                                                              ? TypeSectionTwoColumn
                                                              : K extends typeof ComponentContentTypes.SingleColumn
                                                                ? TypeSingleColumn
                                                                : K extends typeof ComponentContentTypes.SectionGroup
                                                                  ? TypeSectionGroup
                                                                  : K extends typeof ComponentContentTypes.SectionGoTemplatesTool
                                                                    ? TypeSectionGoTemplatesTool
                                                                    : K extends typeof ComponentContentTypes.VariationContainerDeviceType
                                                                      ? TypeVariationContainerAuthAndDeviceTypeCta
                                                                      : K extends typeof ComponentContentTypes.VariationContainerAuthAndDeviceTypeCta
                                                                        ? TypeVariationContainerDeviceType
                                                                        : K extends typeof ComponentContentTypes.SectionTabs
                                                                          ? TypeSectionTabs
                                                                          : K extends typeof ComponentContentTypes.SectionLinkableBoxes
                                                                            ? TypeSectionLinkableBoxes
                                                                            : K extends typeof ComponentContentTypes.SectionDynamic
                                                                              ? TypeSectionDynamic
                                                                              : never

export const isTypeSectionSingleColumn = (entry?: Contentful.Entry<unknown>): entry is TypeSectionSingleColumn => {
  return !!entry && entry.sys?.contentType?.sys.id === ComponentContentTypes.SectionSingleColumn
}

export const isTypeSectionTwoColumn = (entry?: Contentful.Entry<unknown>): entry is TypeSectionTwoColumn => {
  return !!entry && entry.sys?.contentType?.sys.id === ComponentContentTypes.SectionTwoColumns
}

export const isTypeSectionHero = (entry?: Contentful.Entry<unknown>): entry is TypeSectionHero => {
  return !!entry && entry.sys?.contentType?.sys.id === ComponentContentTypes.SectionHero
}

export const isTypeSectionGrammarCheck = (entry?: Contentful.Entry<unknown>): entry is TypeSectionGrammarCheck => {
  return !!entry && entry.sys?.contentType?.sys.id === ComponentContentTypes.SectionGrammarCheck
}

export const isTypeSectionGroup = (entry?: Contentful.Entry<unknown>): entry is TypeSectionGroup => {
  return !!entry && entry.sys?.contentType?.sys.id === ComponentContentTypes.SectionGroup
}

export const isTypeSectionTrustedBy = (entry?: Contentful.Entry<unknown>): entry is TypeSectionTrustedBy => {
  return !!entry && entry.sys?.contentType?.sys.id === ComponentContentTypes.SectionTrustedBy
}

export const isTypeComponentCtaButton = (entry?: Contentful.Entry<unknown>): entry is TypeComponentCtaButton => {
  return !!entry && entry.sys?.contentType?.sys.id === ComponentContentTypes.ComponentCtaButton
}

export const isTypeComponentEmptyStub = (entry?: Contentful.Entry<unknown>) => {
  return !!entry && entry.sys?.contentType?.sys.id === ComponentContentTypes.ComponentEmptyStub
}

export const isTypeComponentDynamic = (entry?: Contentful.Entry<unknown>): entry is TypeComponentDynamic => {
  return !!entry && entry.sys?.contentType?.sys.id === ComponentContentTypes.ComponentDynamic
}

export const isTypeComponentTextInput = (entry?: Contentful.Entry<unknown>): entry is TypeComponentTextInput => {
  return !!entry && entry.sys?.contentType?.sys.id === ComponentContentTypes.ComponentTextInput
}

export const isTypeComponentSelect = (entry?: Contentful.Entry<unknown>): entry is TypeComponentSelect => {
  return !!entry && entry.sys?.contentType?.sys.id === ComponentContentTypes.ComponentSelect
}

export const isTypeVariationContainerAuthAndDeviceTypeCta = (
  entry?: Contentful.Entry<unknown>
): entry is TypeVariationContainerAuthAndDeviceTypeCta => {
  return !!entry && entry.sys?.contentType?.sys.id === ComponentContentTypes.VariationContainerAuthAndDeviceTypeCta
}

export const isTypeItemTestimonial = (entry?: Contentful.Entry<unknown>): entry is TypeItemTestimonial => {
  return !!entry && entry.sys?.contentType?.sys.id === ComponentContentTypes.ItemTestimonial
}

export const isTypeItemEventOrArticle = (entry?: Contentful.Entry<unknown>): entry is TypeItemEventOrArticle => {
  return !!entry && entry.sys?.contentType?.sys.id === ComponentContentTypes.ItemEventOrArticle
}

export const isTypeAssetLottieInteractiveAnimation = (
  entry?: Contentful.Entry<unknown>
): entry is TypeAssetLottieInteractiveAnimation => {
  return entry?.sys?.contentType?.sys.id === ComponentContentTypes.AssetLottieInteractiveAnimation
}

export const isTypeVariationContainerDeviceType = (
  entry?: Contentful.Entry<unknown>
): entry is TypeVariationContainerDeviceType => {
  return !!entry && entry.sys?.contentType?.sys.id === ComponentContentTypes.VariationContainerDeviceType
}

export const isTypeVariationConditionalSelect = (
  entry?: Contentful.Entry<unknown>
): entry is TypeVariationConditionalSelect => {
  return !!entry && entry.sys?.contentType?.sys.id === ComponentContentTypes.VariationContainerConditionalSelect
}

export const isUnresolvedLink = (
  entry?: UnresolvedEntryLink | Contentful.Entry<unknown>
): entry is UnresolvedEntryLink => {
  return (
    !!entry &&
    entry.sys.type === 'Link' &&
    'linkType' in entry.sys &&
    entry.sys.linkType === 'Entry' &&
    !('fields' in entry)
  )
}
